// Custom header JS here.

document.addEventListener('DOMContentLoaded', function () {
    const menu = document.getElementById('pull-menu');
    const openButton = document.getElementById('pull-menu-open');
    const closeButton = document.getElementById('pull-menu-close');
    const overlay = document.getElementById('overlay');
    const menuLinks = menu.querySelectorAll('a'); // Select all links within the menu

    function openMenu() {
        menu.classList.add('open');
        overlay.style.display = 'block';
        closeButton.style.display = 'block';
        menu.setAttribute('aria-hidden', 'false');
    }

    function closeMenu() {
        menu.classList.remove('open');
        overlay.style.display = 'none';
        closeButton.style.display = 'none';
        menu.setAttribute('aria-hidden', 'true');
    }

    openButton.addEventListener('click', openMenu);
    closeButton.addEventListener('click', closeMenu);
    overlay.addEventListener('click', closeMenu);

    // Add event listeners to each link in the menu to close the menu on click
    menuLinks.forEach(link => {
        link.addEventListener('click', closeMenu);
    });
});